import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";
import LemburForm from "./components/LemburForm";
import PiketHarianForm from "./components/PiketHarianForm";
import PiketPerconnoteForm from "./components/PiketPerconnoteForm";
import KasbonForm from "./components/KasbonForm";
import CicilanForm from "./components/CicilanForm";
import TitipForm from "./components/TitipForm";

export default function KeuanganFormPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const jenis = location.state?.jenis || searchParams.get("jenis") || (location.pathname === "/handover" ? "titip" : "lembur"); // lembur | piket_harian | perconnote | titip

    // Menentukan judul dan form yang dirender
    let title = "Form Pengajuan";
    let FormComponent = null;

    if (jenis === "lembur") {
        title = "⏰ Form Lembur";
        FormComponent = LemburForm;
    } else if (jenis === "piket_harian" || jenis === "piket") {
        title = "🏢 Form Piket Harian";
        FormComponent = PiketHarianForm;
    } else if (jenis === "perconnote" || jenis === "piket_perconnote") {
        title = "📦 Form Piket Perconnote";
        FormComponent = PiketPerconnoteForm;
    } else if (jenis === "kasbon") {
        title = "💸 Form Kasbon";
        FormComponent = KasbonForm;
    } else if (jenis === "cicilan") {
        title = "📑 Form Cicilan";
        FormComponent = CicilanForm;
    } else if (jenis === "titip") {
        title = "📦 Serah Terima Barang/Dokumen";
        FormComponent = TitipForm;
    }

    return (
        <div style={{ minHeight: "100vh", background: "#f8fafc", paddingBottom: 100 }}>
            {/* HEADER */}
            <div style={{ height: 70, display: "flex", alignItems: "center", padding: "0 16px" }}>
                <motion.button
                    onClick={() => navigate(-1)}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    whileTap={{ scale: 0.9 }}
                    style={{
                        width: 40, height: 40,
                        display: "flex", alignItems: "center", justifyContent: "center",
                        background: "#fff", borderRadius: "50%",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                        cursor: "pointer", border: "none",
                    }}
                    aria-label="Kembali"
                >
                    <ArrowLeft size={22} color="#333" />
                </motion.button>

                <h3 style={{ marginLeft: 12, fontSize: 18, fontWeight: 700 }}>
                    {title}
                </h3>
            </div>

            {/* CONTENT */}
            <div style={{ padding: "0 16px 10px 16px" }}>
                {FormComponent && <FormComponent isModalOpen={true} onClose={() => navigate(-1)} />}
            </div>
        </div>
    );
}
